"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _widgetContext = require("../../context/widgetContext");
var _Menu = require("../../components/Menu");
var _analytics = require("../../analytics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MenuContainer = props => {
  const {
    activeIndex = 3
  } = props;
  const {
    targetPage,
    isWebview
  } = React.useContext(_widgetContext.widgetContext);
  const handleClick = React.useCallback((e, index, menuItem) => {
    if (activeIndex === index) {
      e.preventDefault();
      return;
    }
    (0, _analytics.trackMenuItemClick)(targetPage, menuItem);
  }, [activeIndex, targetPage]);
  if (isWebview) {
    return null;
  }
  return /*#__PURE__*/React.createElement(_Menu.Menu, {
    activeIndex: activeIndex,
    onClick: handleClick
  });
};
exports.MenuContainer = MenuContainer;